module.exports = __webpack_public_path__ + "img/icon1.49196bb3.png";